import { Modal } from "react-daisyui"
import { acceptanceSteps, progressLabels, statusIcons, getTxpProgress } from "./hepler"
import { useNavigate } from "react-router-dom"
import { PORTAL_ROUTES } from "utils/constants"

const AcceptanceHistoryModal = ({ isOpen, onClose, treatmentPlan }) => {
  const navigate = useNavigate()
  const { progress, completedSteps } = getTxpProgress[treatmentPlan?.step] || {}

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      backdrop
      className="max-w-xl rounded-3xl border-none shadow-2xl bg-gray-50 p-0 overflow-hidden"
    >
      <Modal.Body className="p-0 pb-6">
        <div className="flex justify-center py-3">
          <div className="w-10 h-1 bg-gray-300 rounded-full" />
        </div>

        <div className="px-6 pb-4">
          <h2 className="text-lg font-bold text-secondary-900 leading-tight">Treatment Plan Acceptance History</h2>
          <p className="text-xs text-secondary-500 mt-1">Progress Overview: {completedSteps} of 5 steps completed</p>
        </div>

        <div className="mx-5 bg-white rounded-2xl p-4 border border-slate-100 shadow-sm">
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-bold text-secondary-900">Overall Progress</span>
            <span className="text-sm font-bold text-blue-600">{progress}</span>
          </div>

          <div className="w-full bg-gray-100 rounded-full h-2 overflow-hidden mb-3">
            <div className="bg-blue-600 h-full rounded-full transition-all duration-700 ease-out" style={{ width: `${progress}` }} />
          </div>

          <div className="flex justify-between">
            {progressLabels.map((label) => (
              <span key={label} className="text-[10px] font-medium text-secondary-500">{label}</span>
            ))}
          </div>
        </div>

        <div className="px-5 pt-4 space-y-3 max-h-[480px] overflow-y-auto">
          {acceptanceSteps.map((step) => {
            const currentStepNo = completedSteps + 1
            const isActive = step.id == currentStepNo
            const isPending = step.id > currentStepNo

            let _status = step.id == currentStepNo ? "in_progress" : step.id < currentStepNo ? "completed" : "pending"
            let { icon, className, title, fontColor, statusIcon } = statusIcons[_status] || {}

            return (
              <div key={step.id}
                className={`rounded-2xl p-4 transition-all duration-200 ${isActive ? "bg-blue-50 border-2 border-blue-200 shadow-sm"
                  : isPending ? "bg-white border border-slate-100" : "bg-white border border-slate-100 shadow-sm"}`}>
                <div className="flex items-start gap-3">
                  <div className={`flex items-center justify-center w-8 h-8 rounded-full ${className} shrink-0`}>
                    {icon}
                  </div>

                  <div className="flex-1 min-w-0">
                    <h4 className={`text-sm font-bold leading-snug ${isPending ? "text-gray-400"
                      : isActive ? "text-blue-700" : "text-secondary-900"}`}>
                      {step.title}
                    </h4>

                    <p className={`text-xs mt-0.5 ${isPending ? "text-gray-300"
                      : isActive ? "text-blue-500" : "text-secondary-500"}`}>
                      {step.description}
                    </p>

                    {_status !== "pending" && (
                      <div className="flex items-center gap-1 mt-1.5">
                        {statusIcon}
                        <span className={`text-xs font-semibold ${fontColor}`}>{title}</span>
                      </div>
                    )}

                    {isActive && (
                      <p
                        className="text-xs text-blue-600 font-medium mt-1 cursor-pointer hover:underline"
                        onClick={() => navigate(`${PORTAL_ROUTES.TREATMENT_PLANS}/${treatmentPlan?.encoded_id}/review`)}
                      >Tap to navigate</p>
                    )}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default AcceptanceHistoryModal
